export {data};

import API_URL from '../../includes/api.js';
import {resolveTenantData} from '../../tenant/site-configs.js';
import {fetchApiJson, refererHeaders} from '../../includes/server-fetch.js';

// Mirrors Playlist.jsx's fetchSongs(0, true) (same endpoint/page size) so the client
// can skip its redundant first fetch after hydration.
//
// +data.shared.js is NOT cumulative in Vike — this page-level file replaces the root
// one, so it must resolve+spread tenant data itself or lose messages/faq/about.
const PAGE_SIZE = 50;

async function data(pageContext) {
    const tenantData = resolveTenantData(pageContext);
    const p = pageContext.urlParsed?.search?.p ?? '';
    if (!p || !import.meta.env.SSR) return {...tenantData, playlist: null, songs: [], total: null, apiHasMore: null};

    // Playlist.jsx's client-side fetch still runs after hydration and will
    // retry.
    const result = await fetchApiJson(`${API_URL}/playlist/get?p=${encodeURIComponent(p)}&limit=${PAGE_SIZE}&offset=0`, refererHeaders(pageContext), pageContext);
    if (result.ok) {
        const total = Number(result.data?.pagination?.total ?? result.data?.total);
        return {
            ...tenantData,
            playlist: result.data?.playlist ?? {},
            songs: result.data?.songs ?? [],
            total: Number.isFinite(total) ? total : null,
            apiHasMore: result.data?.has_more ?? null,
        };
    }
    return {...tenantData, playlist: null, songs: [], total: null, apiHasMore: null};
}
